import _ from "lodash";
import type { Order, OrderItem } from "@/schemas/order";

/** Menu pizzas are named "<type id>. <name>"; drinks, sides etc. are not. */
const PIZZA_ITEM_NAME = /\d+\.\s.*/;

export const isPizzaItem = (item: Pick<OrderItem, "name">) =>
  !!item.name && PIZZA_ITEM_NAME.test(item.name);

/** [pizza items, other items] of an order */
export const splitOrderItems = (items: OrderItem[] | undefined | null) =>
  _.partition(items ?? [], isPizzaItem);

export const orderPizzaItems = (order: Pick<Order, "items"> | null | undefined) =>
  (order?.items ?? []).filter(isPizzaItem);

/** "5. Šunková" -> { typeId: "5", name: "Šunková" } */
export function parsePizzaName(name: string | null | undefined) {
  const match = name?.match(/^[^0-9]*\s?(\d+)\.\s(.*)/);
  return match ? { typeId: match[1], name: match[2] } : { typeId: null, name: name ?? "" };
}
